/* eslint-disable */
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useTranslation } from "../../locale/useTranslation";
import { getSelectedState, Grid, GridColumn as Column, } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-data-query";
import * as API from "../../framework/API/api";
import { ENTITYNAME, MEDIACATEGORIES, MEDIACATEGORYTYPES, MODULE, SOCKET_ACTION, SOCKET_EVENTS, TOAST_TYPES } from "../../framework/constant/constant";
import RefreshButton from "../../framework/forms/helpercomponents/buttons/RefreshButton";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { ImageCell } from "../../framework/forms/helpercomponents/CustomGridCells/ImageCell";
import MyStatusCell from "../../components/MyStatusCell";
import { DateCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import { TimeCell } from "../../framework/forms/helpercomponents/CustomGridCells/TimeCell";
import { MyPublishedChannelArrayCell } from "../LiveEvents/components/MyPublishedChannelArrayCell";
import { ContextMenu } from "primereact/contextmenu";
import { LiveMatchEditForm } from "../LiveEvents/components/LiveMatchEditForm";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import { TimePickerWithFormat } from "../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import moment from "moment";
import { EditPageHeader } from "../../components/EditPageHeader";
import { utility } from "../../framework/utility/utilityProvider";
import UnPublishSelectionCollection from "../LiveEvents/components/unPublishSelectionCollection";
import useSocket from "../../framework/socket/useSocket";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";
import { MultiLiveMatchEditDialog } from "../LiveEvents/components/MultiLiveMatchEditDialog";
import { ConfirmAlert } from "../../ConfirmAlert";

const SELECTED_FIELD = "selected";
const DATA_ITEM_KEY = "_id";
const idGetter = getter(DATA_ITEM_KEY);

const PlanningLiveEventsTab = (props, ref) => {

    const lang = useTranslation();

    const [isLoading, setIsLoading] = useState(true);
    const [gridData, setGridData] = useState([]);
    const [page, setPage] = useState({ skip: 0, take: 50 });
    const [searchText, setSearchText] = useState("");
    const [tournamentValue, setTournamentValue] = useState({ SID: 0, Name: "All" });
    const [tournaments, setTournaments] = useState([]);
    const [total, setTotal] = useState(1);
    const [showAll, setShowAll] = useState(false);
    const [filterDataItem, setFilterDataItem] = useState({
        isLive: true,
        weekStartDate: props.payload.startDate,
        weekEndDate: props.payload.endDate,
        // channels : props.payload.channels
    });
    const [showMatchEditForm, setShowMatchEditForm] = useState(false);
    const [showMultiEditForm, setShowMultiEditForm] = useState(false);
    const [showPublishMenu, setShowPublishMenu] = useState(false);
    const [openPopupScheduleMatch, setOpenPopupScheduleMatch] = useState(false);
    const [scheduleMatchDataItem, setScheduleMatchDataItem] = useState({});
    const [multiPublishItems, setMultiPublishItems] = useState([]);
    const [allChannels, setAllChannels] = useState([]);
    const [openCollectionSelectionUnPublish, setOpenCollectionSelectionUnPublish] = useState(false);
    const [selectedState, setSelectedState] = useState({});
    const [multiSelectedItems, setMultiSelectedItems] = useState([]);

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState,
            dataItemKey: DATA_ITEM_KEY,
        });
        setSelectedState(newSelectedState);
        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];
        selectedIds.forEach((value) => {
            if (newSelectedState[value]) {
                let filter = gridData.find((obj) => obj._id == value);
                if (filter) tempSelected.push(filter);
            }
        });
        setMultiSelectedItems(tempSelected);
    };

    const onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = {};
        event.dataItems.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });
        setSelectedState(newSelectedState);
        let selectedIds = Object.keys(newSelectedState);
        let tempSelected = [];
        if (checked) {
            selectedIds.forEach((value) => {
                if (newSelectedState[value]) {
                    let filtered = gridData.find((obj) => obj._id == value);
                    if (filtered) tempSelected.push(filtered);
                }
            });
        }
        setMultiSelectedItems(tempSelected);
    };

    useEffect(() => {
        let selectedIds = Object.keys(selectedState);
        let tempSelected = [];
        selectedIds.forEach((value) => {
            if (selectedState[value]) {
                let filter = gridData.find((obj) => obj._id == value);
                if (filter) tempSelected.push(filter);
            }
        });
        setMultiSelectedItems(tempSelected);
    }, [gridData]);

    const contextMenuRef = useRef(null);
    const selectedItemsRef = useRef([]);
    const setSelectedItemRef = (data) => {
        selectedItemsRef.current = data;
    }
    const matchItem = useRef({ SID: 0 });
    const setMatchItem = (data) => {
        matchItem.current = data;
    };

    const unPublishRef = useRef({});
    const setUnPublishRef = (data) => {
        unPublishRef.current = data;
    };

    const liveEventTournamentRef = useRef({});
    const setLiveEventTournamentRef = (data) => {
        liveEventTournamentRef.current = data;
    }

    useEffect(() => {
        loadCombo();

        setFilterDataItem({
            isLive: true,
            weekStartDate: props.payload.startDate,
            weekEndDate: props.payload.endDate,
            // channels : props.payload.channels
        })
        if (props.channels.length > 0) {
            loaddata('', {
                isLive: true,
                weekStartDate: props.payload.startDate,
                weekEndDate: props.payload.endDate,
                // channels : props.payload.channels
            });
        }
    }, [props.channels, props.payload]);

    const socket = useSocket(SOCKET_EVENTS.onSocketData, (socketData) => {

        //console.log(socketData)
        if (socketData.module != MODULE.LIVE_EVENTS) return;


        switch (socketData.action) {
            case SOCKET_ACTION.LIVE_EVENT_REFRESH:
                loaddata('', filterDataItem);
                break;
            default:
                break;
        }

    });

    const onSearch = (e) => {
        e.preventDefault();
        let text = e.target.value?.trim();
        setSearchText(text);
    };

    // Search 
    useEffect(() => {
        if (searchText != "") {
            const timeOut = setTimeout(() => {
                setIsLoading(true);
                loaddata(searchText, filterDataItem);
            }, 700);
            return () => clearTimeout(timeOut);
        } else {
            setIsLoading(true);
            loaddata('', filterDataItem);
        }
    }, [searchText]);

    useImperativeHandle(ref, () => {
        return {
            onRefresh() {
                onRefresh()
            },
        };
    }, []);


    const loadCombo = async () => {
        let tournamentRes = await API.getDataLookup(ENTITYNAME.Tournament, { sort: { Name: 1 } });
        tournamentRes.data.unshift({ SID: 0, Name: "All" });
        setTournaments(tournamentRes.data);

        let channelRes = await API.getValidChannels();
        if (channelRes?.success && channelRes?.data) {
            setAllChannels(channelRes.data);
        } else {
            let fallbackChannels = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
            setAllChannels(fallbackChannels?.data ?? []);
        }
    }

    const onShowAllClick = () => {

        setShowAll(!showAll);

        let current_page = page.skip / page.take + 1;
        let filters = { ...filterDataItem }

        if (!showAll) {
            delete filters.weekStartDate
            delete filters.weekEndDate
            // delete filters.channels
            setFilterDataItem(filters)
            loaddata(searchText, filters, { per_page: page.take, current_page: current_page, orderby: "SID", direction: "asc" });
        } else {
            filters.weekStartDate = props.payload.startDate
            filters.weekEndDate = props.payload.endDate
            // filters.channels : props.payload.channels
            setFilterDataItem(filters)
            loaddata(searchText, filters, { per_page: page.take, current_page: current_page, orderby: "SID", direction: "asc" });
        }
    }

    const loaddata = async (searchText, filters, pagination = { per_page: page.take, current_page: 1, orderby: "SID", direction: "asc" }) => {
        props.showLoading && setIsLoading(true);
        console.log(filters)
        const response = await API.loadPlanningMediaLibrary(searchText, filters, pagination, props.channels);
        console.log(response);
        if (response.success) {
            // SORT BY StartDateTime
            response.data.sort((a, b) => (a.mediaepisodedetailliveevent.StartDateTime > b.mediaepisodedetailliveevent.StartDateTime) ? 1 : -1);
            setGridData(response.data ?? []);
            setTotal(response.pagination.total);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
            setGridData([]);
        }
        setIsLoading(false);
    }

    const onRefresh = () => {
        console.log('here live')
        let current_page = page.skip / page.take + 1;
        loaddata(searchText, filterDataItem, { per_page: page.take, current_page: current_page, orderby: "SID", direction: "asc" });
    }

    const StatusCell = (props) => {
        let title = "NOT SCHEDULED";
        if (props.dataItem?.mediaepisodedetailliveevent?.ScheduleStatus?.length > 0) {
            title = "SCHEDULED";
        }
        return (
            <MyStatusCell
                {...props}
                title={title}
                titleColor="#ffffff"
                tileBackColor={title == "SCHEDULED" ? "#47A992" : "#E76161"}
                margin={"20px 10px"}
                titleFontSize={"12px"}
            />
        );
    };

    const pageChange = async (e) => {
        let current_page = e.page.skip / e.page.take + 1;
        await loaddata(searchText, filterDataItem, { per_page: e.page.take, current_page: current_page, orderby: "SID", direction: "asc" });
        setPage(e.page);
    };

    const onChange = (e) => {
        setTournamentValue(e.target.value);
        let filters = { ...filterDataItem };
        if (e.target.value.SID != 0) {
            filters.Tournament_id = e.target.value._id;
        } else {
            delete filters.Tournament_id;
        }
        loaddata(searchText, filters);
        setFilterDataItem(filters);
    }

    const editMatch = (index, dataItem) => {
        setMatchItem(dataItem);
        let tournamnetData = tournaments.find((item) => item._id == dataItem.Tournament_id && item.SID != 0);
        setLiveEventTournamentRef(tournamnetData)
        setShowMatchEditForm(true);
    };

    const getTournamentChannels = (item) => {
        const tourId = item?.mediaepisodedetailliveevent?.Tournament_id || item?.Tournament_id;
        const tour = tournaments.find((t) => (t._id === tourId || t.SID === tourId) && t.SID !== 0);
        if (tour) {
            if (Array.isArray(tour.Channels) && tour.Channels.length > 0) {
                return tour.Channels;
            }
            if (Array.isArray(tour.Channel) && tour.Channel.length > 0) {
                return tour.Channel;
            }
        }
        return props.channels ?? [];
    };

    const onScheduleMatch = (index, dataItem) => {
        setOpenPopupScheduleMatch(true);
        if (multiSelectedItems.length > 1) {
            const items = multiSelectedItems.map((elem) => ({
                ...elem,
                _id: elem._id,
                Title: elem.Title || elem.mediaepisodedetailliveevent?.Title || "",
                AssetId: elem.AssetId || "",
                Channels: getTournamentChannels(elem),
                StartDate: elem.mediaepisodedetailliveevent?.StartDateTime
                    ? moment(new Date(elem.mediaepisodedetailliveevent.StartDateTime)).utc().format("YYYY-MM-DD")
                    : moment(new Date()).utc().format("YYYY-MM-DD"),
                StartTime: elem.mediaepisodedetailliveevent?.StartDateTime
                    ? moment(new Date(elem.mediaepisodedetailliveevent.StartDateTime)).utc().format("HH:mm:ss:SS")
                    : "00:00:00:00",
            }));
            setMultiPublishItems(items);
        } else {
            let item = {
                ...dataItem,
                Channels: getTournamentChannels(dataItem),
                StartDate: moment(new Date(dataItem.StartDateTime)).utc().format("YYYY-MM-DD"),
                StartTime: moment(new Date(dataItem.StartDateTime)).utc().format("HH:mm:ss:SS"),
            };
            setScheduleMatchDataItem(item);
        }
    };

    const onChangeMultiPublishChannels = (index, value) => {
        setMultiPublishItems((prevItems) =>
            prevItems.map((item, idx) => (idx === index ? { ...item, Channels: value } : item))
        );
    };

    const onUnPublish = (index, dataItem) => {

        //CHECK IF IT IS PUBLISHED OR NOT
        if (dataItem.ScheduleStatus.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Not published yet` });
            return false;
        }

        setOpenCollectionSelectionUnPublish(true);
        setUnPublishRef(dataItem);
    };

    //onPublish
    const onPublish = async () => {
        const currentDateInMillisec = utility.getLocalDateTimeToUtcMiliseconds(new Date());

        if (multiSelectedItems.length > 1) {
            for (const item of multiPublishItems) {
                if (!item.Channels || item.Channels.length === 0) {
                    ToastNotification({
                        type: TOAST_TYPES.ERROR,
                        title: lang.invalid_error_message_title,
                        message: `Please select channel for ${item.Title || item.AssetId}`,
                    });
                    return false;
                }
            }

            setOpenPopupScheduleMatch(false);

            for (const item of multiPublishItems) {
                let slotdatetime = utility.getLocalDateTimeToUtcMiliseconds(
                    new Date(`${item.StartDate} ${item.StartTime}`)
                );
                let payload = {
                    MediaEpisode_id: item._id,
                    SlotDateTime: slotdatetime,
                    ScheduleDate: slotdatetime,
                    Channel: item.Channels,
                    MediaEpisodeLiveEventDetail_id: item.mediaepisodedetailliveevent?._id,
                };

                var scheduleResponse = await API.scheduleMatch(payload);

                if (scheduleResponse.success) {
                    for (let index = 0; index < payload.Channel.length; index++) {
                        const ch = payload.Channel[index];

                        socket?.emit(SOCKET_EVENTS.onSocketData, {
                            action: SOCKET_ACTION.PLANNING_REFRESH,
                            module: MODULE.PLANNING,
                            data: {
                                scheduleScheduleStartDate: payload.SlotDateTime,
                                scheduleScheduleEndDate: payload.SlotDateTime,
                                channelSID: ch.SID,
                            },
                        });
                    }
                }
            }

            onRefresh();
            props.planningLoading();
            ToastNotification({
                type: TOAST_TYPES.SUCCESS,
                title: lang.success_message_title,
                message: lang.match_scheduled_successfully_message,
            });
            setMultiPublishItems([]);
            return;
        }

        //CHANNEL VALIDATION
        if (!scheduleMatchDataItem?.Channels || scheduleMatchDataItem?.Channels?.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }

        if (multiSelectedItems.length <= 1) {
            //CANNOT SCHEDULE MATCH BEFORE CURRENT DATE
            if (currentDateInMillisec > scheduleMatchDataItem.StartDateTime) {
                let msg = scheduleMatchDataItem?.Type?.Description == "Live"
                    ? `Cannot schedule ${scheduleMatchDataItem?.Type?.Description}, schedule date already passed`
                    : `Cannot schedule ${scheduleMatchDataItem?.Type?.Description} before current date `;
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: msg });
                return false;
            }

            //CANNOT SCHEDULE MATCH BEFORE LIVE DATE
            if (
                !scheduleMatchDataItem?.MediaEpisode?.IsLive &&
                scheduleMatchDataItem.StartDateTime >
                utility.getLocalDateTimeToUtcMiliseconds(
                    new Date(scheduleMatchDataItem.StartDate)
                )
            ) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: ` Cannot schedule ${scheduleMatchDataItem?.Type?.Description} before live start date ` });
                return false;
            }
        }

        setOpenPopupScheduleMatch(false);

        let slotdatetime = utility.getLocalDateTimeToUtcMiliseconds(
            new Date(
                `${scheduleMatchDataItem.StartDate} ${scheduleMatchDataItem.StartTime}`
            )
        );

        var payload = {
            MediaEpisode_id: scheduleMatchDataItem?.MediaEpisode?._id || scheduleMatchDataItem?._id,
            SlotDateTime: slotdatetime,
            ScheduleDate: slotdatetime,
            Channel: scheduleMatchDataItem.Channels,
            MediaEpisodeLiveEventDetail_id: scheduleMatchDataItem._id,
        };

        var scheduleResponse = await API.scheduleMatch(payload);

        if (scheduleResponse.success) {
            for (let index = 0; index < payload.Channel.length; index++) {
                const ch = payload.Channel[index];

                socket?.emit(SOCKET_EVENTS.onSocketData, {
                    action: SOCKET_ACTION.PLANNING_REFRESH,
                    module: MODULE.PLANNING,
                    data: { scheduleScheduleStartDate: payload.SlotDateTime, scheduleScheduleEndDate: payload.SlotDateTime, channelSID: ch.SID },
                });
            }
        }

        onRefresh();
        props.planningLoading();
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.match_scheduled_successfully_message });
        setScheduleMatchDataItem({
            Channels: [],
            StartDate: "",
            StartTime: "",
        });
    };

    //CONTEXT MENU TILE VIEW
    const publishMenu = [
        { label: lang.edit_actionbutton_option, icon: "fa-solid fa-pencil fa-lg", command: () => { editMatch(0, selectedItemsRef.current) } },
        { label: lang.publish_match_label, icon: "fa-solid fa-calendar-days fa-lg", command: () => { onScheduleMatch(0, selectedItemsRef.current) } },
    ];

    const unPublishMenu = [
        { label: lang.edit_actionbutton_option, icon: "fa-solid fa-pencil fa-lg", command: () => { editMatch(0, selectedItemsRef.current) } },
        { label: lang.un_publish_match_label, icon: "fa-solid fa-calendar-days fa-lg", command: () => { onUnPublish(0, selectedItemsRef.current) } },
    ];

    const allScheduled = multiSelectedItems.length > 1 && multiSelectedItems.every(
        (item) => item.mediaepisodedetailliveevent?.ScheduleStatus?.length > 0
    );
    const allUnpublished = multiSelectedItems.length > 1 && multiSelectedItems.every(
        (item) => !item.mediaepisodedetailliveevent?.ScheduleStatus || item.mediaepisodedetailliveevent?.ScheduleStatus?.length === 0
    );

    const handleUnPublishMulti = () => {
        ConfirmAlert(
            async () => {
                for (const item of multiSelectedItems) {
                    const detail = item.mediaepisodedetailliveevent;
                    if (!detail || !detail.ScheduleStatus || detail.ScheduleStatus.length === 0) continue;

                    for (const obj of detail.ScheduleStatus) {
                        let payload = {
                            _id: obj.ProgramSchedule_id,
                            MediaDealRight_id: "",
                        };
                        await API.deletePlanning(payload);
                    }

                    await API.saveData(ENTITYNAME.MediaEpisodeDetailLiveEvent, {
                        _id: detail._id,
                        ScheduleStatus: [],
                        IsScheduled: false,
                    });

                    if (detail.ScheduleStatus.length > 0) {
                        const firstSlot = detail.ScheduleStatus[0];
                        socket?.emit(SOCKET_EVENTS.onSocketData, {
                            action: SOCKET_ACTION.PLANNING_REFRESH,
                            module: MODULE.PLANNING,
                            data: {
                                scheduleScheduleStartDate: firstSlot.SlotDateTime,
                                scheduleScheduleEndDate: firstSlot.SlotDateTime,
                                channelSID: firstSlot.Channel?.SID,
                            },
                        });
                    }
                }

                onRefresh();
                props.planningLoading();
                ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Un-Published successfully!!" });
            },
            () => {},
            "Confirm",
            "Are you sure you want to un-publish all selected matches?"
        );
    };

    const getMultiSelectContextMenu = () => {
        if (allScheduled) {
            return [
                { label: lang.edit_actionbutton_option, icon: "fa-solid fa-pencil fa-lg", command: () => { setShowMultiEditForm(true); } },
                { label: lang.un_publish_match_label, icon: "fa-solid fa-calendar-days fa-lg", command: () => { handleUnPublishMulti(); } },
            ];
        } else if (allUnpublished) {
            return [
                { label: lang.edit_actionbutton_option, icon: "fa-solid fa-pencil fa-lg", command: () => { setShowMultiEditForm(true); } },
                { label: lang.publish_match_label, icon: "fa-solid fa-calendar-days fa-lg", command: () => { onScheduleMatch(0, selectedItemsRef.current); } },
            ];
        } else {
            return [
                { label: lang.edit_actionbutton_option, icon: "fa-solid fa-pencil fa-lg", command: () => { setShowMultiEditForm(true); } },
                {
                    label: lang.publish_match_label,
                    icon: "fa-solid fa-calendar-days fa-lg",
                    command: () => {
                        ToastNotification({
                            type: TOAST_TYPES.ERROR,
                            title: lang.invalid_error_message_title,
                            message: "Selection contains both published and unpublished matches. Please select items with the same status.",
                        });
                    },
                },
            ];
        }
    };

    const onContextMenu = (e) => {
        e.syntheticEvent.preventDefault();
        contextMenuRef.current.show(e.syntheticEvent);
        let prepareData = {
            ...e?.dataItem?.mediaepisodedetailliveevent,
            MediaEpisode: e?.dataItem
        }
        setSelectedItemRef(prepareData);
        setShowPublishMenu(prepareData?.ScheduleStatus?.length == 0 ? true : false)
    }

    const onAddMatch = () => {
        setMatchItem({ SID: 0 });
        setShowMatchEditForm(true);
    };

    const onChangeScheduleMatch = (e) => {
        setScheduleMatchDataItem({
            ...scheduleMatchDataItem,
            [e.target.name]: e.target.value,
        });
    };

    const unPublish = async (dataList) => {

        setOpenCollectionSelectionUnPublish(false);
        let tempScheduleStatus = unPublishRef.current.ScheduleStatus;

        for (let i = 0; i < dataList.length; i++) {
            const obj = dataList[i];

            //call delete planning api here
            let payload = {
                _id: obj.ProgramSchedule_id,
                MediaDealRight_id: "",
            };

            // console.log(payload)
            let deleteResponse = await API.deletePlanning(payload);
            console.log(deleteResponse);

            let filter = tempScheduleStatus.filter(
                (x) =>
                    obj.ProgramSchedule_id != x.ProgramSchedule_id &&
                    obj.SlotDateTime != x.SlotDateTime
            );
            tempScheduleStatus = filter;
        }

        let isScheduled = tempScheduleStatus.length > 0 ? true : false

        let updateLiveEventDetail = await API.saveData(ENTITYNAME.MediaEpisodeDetailLiveEvent,
            { _id: unPublishRef.current._id, ScheduleStatus: tempScheduleStatus, IsScheduled: isScheduled }
        );

        if (updateLiveEventDetail.success) {
            onRefresh();
            props.planningLoading();
            socket?.emit(SOCKET_EVENTS.onSocketData, {
                action: SOCKET_ACTION.PLANNING_REFRESH,
                module: MODULE.PLANNING,
                data: { scheduleScheduleStartDate: dataList[0]?.SlotDateTime, scheduleScheduleEndDate: dataList[0]?.SlotDateTime, channelSID: dataList[0]?.Channel?.SID },
            });
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `Un-Published successfully!!` });
        }
    };

    return (<>
        <div style={{ height: "100%", width: "100%!important" }}>
            <div className="row">
                <div className="col-10">
                    <h1 className="page-title" style={{ margin: '8px 0px 15px 0px' }}>
                        <i
                            className="fa fa-table marlr"
                            style={{ fontSize: "20px", color: "GrayText" }}
                        ></i>
                        <span>{lang.live_events_label}</span>
                    </h1>
                </div>
                <div className="col-2 pull-right pt-2">
                    <RefreshButton onClick={onRefresh} />
                </div>
                <div className="col-5 pt-3 pl-3">
                    <AddRoundButton
                        title={lang.create_event_button_tooltip}
                        name={lang.create_event_button_text}
                        onClick={onAddMatch}
                    />
                </div>
                <div className="col-3 d-inline mt-4" style={{ padding: "0px 0px 0px 28px" }}>
                    <input type='checkbox' name='FilteredArchive' checked={showAll} onClick={onShowAllClick} onChange={() => { }} />  {lang.show_all_label}
                </div>
                <div className="col-4 pull-right" style={{ padding: "0px 26px 0px 0px" }}>
                    <label >{lang.tournament_label}</label>
                    <DropDownList
                        style={{ backgroundColor: "white" }}
                        data={tournaments}
                        name="Tournament"
                        textField="Name"
                        dataItemKey="SID"
                        value={tournamentValue}
                        onChange={onChange}
                    />
                </div>
                <div className="flex-container">
                    <div className="input-group input-group martb marlr pl-3 pr-3" style={{ zIndex: 1 }}>
                        <input
                            type="text"
                            className="form-control shadow-inset-2 pt-0 pb-0"
                            id="searchInput"
                            placeholder={lang.search_button_text}
                            onChange={onSearch}
                            onFocus={(e) => {
                                if (props.setOutSideFocus) {
                                    props.setOutSideFocus(true);
                                }
                            }}
                            onBlur={(e) => {
                                if (props.setOutSideFocus) {
                                    props.setOutSideFocus(false);
                                }
                            }}
                        />
                        <button id="search" style={{ border: "0px", backgroundColor: "white", height: "38px" }} >
                            <div className="input-group-append">
                                <span className="input-group-text">
                                    <i style={{ margin: "4px 0px" }} className="fa fa-search" />
                                </span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            {isLoading && <div className="ml-1">
                <i style={{ fontSize: "20px", color: "GrayText" }} className="fas fa-spinner fa-pulse"></i>
            </div>}
            {!isLoading && <Grid
                style={{ position: "absolute", left: 0, top: "210px", right: 0, bottom: "25px" }}
                data={gridData.map((item) => ({
                    ...item,
                    [SELECTED_FIELD]: selectedState[idGetter(item)],
                }))}
                selectedField={SELECTED_FIELD}
                selectable={{
                    enabled: true,
                    drag: false,
                    cell: false,
                    mode: "multiple",
                }}
                dataItemKey={DATA_ITEM_KEY}
                onSelectionChange={onSelectionChange}
                onHeaderSelectionChange={onHeaderSelectionChange}
                resizable={true}
                pageable={true}
                skip={page.skip}
                take={page.take}
                rowRender={props.MediaLibraryCollectionGridRowRender}
                onPageChange={pageChange}
                onContextMenu={onContextMenu}
                total={total}
            >
                <Column
                    field={SELECTED_FIELD}
                    width="50px"
                    headerSelectionValue={
                        gridData.length > 0 && gridData.findIndex((item) => !selectedState[idGetter(item)]) === -1
                    }
                    filterable={false}
                    resizable={false}
                />
                <Column field="mediaepisodedetailliveevent.PosterUrl" title={"Poster"} editable={false} cell={ImageCell} width={"100px"} />
                <Column field="AssetId" title={lang.assetId_column} editable={false} width={"150px"} />
                <Column field="Title" title={lang.title_column} editable={false} width={"150px"} />
                <Column field="mediaepisodedetailliveevent.ScheduleStatus" title={"Status"} editable={false} width={"150px"} cell={StatusCell} />
                <Column field="StartDateTime" title={"Start Date Time"} editable={false} cell={DateCell} width={"160px"} />
                <Column field="mediaepisodedetailliveevent.Type.Description" title={"Type"} editable={false} width={"100px"} />
                <Column field="mediaepisodedetailliveevent.TeamA" title={"Team A"} editable={false} width={"120px"} />
                <Column field="mediaepisodedetailliveevent.TeamB" title={"Team B"} editable={false} width={"120px"} />
                <Column field="Description" title={lang.description_column} editable={false} width={"150px"} />
                <Column field="Duration" title={lang.duration_column} editable={false} cell={TimeCell} width={"100px"} />
                <Column field="mediaepisodedetailliveevent.Round.Description" title={"Round"} editable={false} width={"100px"} />
                <Column field="mediaepisodedetailliveevent.Venue" title={"Venue"} editable={false} width={"150px"} />
                <Column field="mediaepisodedetailliveevent.ScheduleStatus" cell={MyPublishedChannelArrayCell} title="Published Channel" width={200} format={"Channel.FullChannelName"} />
            </Grid>}
            <div style={{ paddingLeft: '10px', position: "absolute", left: 0, top: "84.2vh", right: 0, bottom: 0 }}>
                <p className="text-muted" style={{ fontSize: "12px" }}>Note : Valid Live Event for Selected Planning Date Range & Channel </p>
            </div>
        </div>


        {showMatchEditForm &&
            <LiveMatchEditForm
                title={lang.match_label}
                entityName={ENTITYNAME.MediaEpisode}
                item={matchItem.current}
                refresh={onRefresh}
                cancelEdit={() => { setShowMatchEditForm(false); setLiveEventTournamentRef({}) }}
                mediaCategory={MEDIACATEGORIES.Program}
                mediaCategoryType={MEDIACATEGORYTYPES.Program}
                selectedTournament={liveEventTournamentRef.current}
                isPlanning={true}
            />}
        <ContextMenu model={multiSelectedItems.length > 1 ? getMultiSelectContextMenu() : (showPublishMenu ? publishMenu : unPublishMenu)} ref={contextMenuRef} />
        {showMultiEditForm && (
            <MultiLiveMatchEditDialog
                open={showMultiEditForm}
                items={multiSelectedItems}
                onClose={() => setShowMultiEditForm(false)}
                onSaveSuccess={onRefresh}
            />
        )}
        {/* un-publish */}
        {openCollectionSelectionUnPublish && (
            <UnPublishSelectionCollection
                title={lang.un_publish_match_label}
                data={unPublishRef.current.ScheduleStatus}
                onConfirm={unPublish}
                closeForm={() => setOpenCollectionSelectionUnPublish(false)}
            />
        )}
        {/* scheduleMatch */}
        {openPopupScheduleMatch && (
            <BossDialog
                title={lang.publish_match_header_dialog}
                onClose={() => {
                    setOpenPopupScheduleMatch(false);
                    setScheduleMatchDataItem({
                        Channels: [],
                        StartDate: "",
                        StartTime: "",
                    });
                    setMultiPublishItems([]);
                }}
                width={multiSelectedItems.length > 1 ? "950px" : "600px"}
            >
                <EditPageHeader showTitle={false} saveButtonTitle={lang.confirm_button_text} onSubmit={onPublish} onCancel={() => {
                    setOpenPopupScheduleMatch(false);
                    setScheduleMatchDataItem({
                        Channels: [],
                        StartDate: "",
                        StartTime: "",
                    });
                    setMultiPublishItems([]);
                }} />
                {multiSelectedItems.length > 1 ? (
                    <div style={{ maxHeight: "60vh", overflowY: "auto" }} className="mt-3">
                        <table className="table table-bordered align-middle mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th style={{ width: "20%" }}>{lang.title_column || "Title"}</th>
                                    <th style={{ width: "40%" }}>{lang.channel_label} *</th>
                                    <th style={{ width: "20%" }}>{lang.start_date_label} *</th>
                                    <th style={{ width: "20%" }}>{lang.start_time_label} *</th>
                                </tr>
                            </thead>
                            <tbody>
                                {multiPublishItems.map((item, idx) => (
                                    <tr key={item._id || idx}>
                                        <td className="align-middle font-weight-bold" style={{ fontSize: "13px" }}>
                                            {item.Title} {item.AssetId ? `(${item.AssetId})` : ""}
                                        </td>
                                        <td className="align-middle">
                                            <MultiSelect
                                                data={getTournamentChannels(item)}
                                                textField="FullChannelName"
                                                dataItemKey="_id"
                                                value={item.Channels || []}
                                                onChange={(e) => onChangeMultiPublishChannels(idx, e.target.value)}
                                                name={`Channels_${idx}`}
                                            />
                                        </td>
                                        <td className="align-middle">
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                name={`StartDate_${idx}`}
                                                value={item.StartDate || ""}
                                                disabled={true}
                                            />
                                        </td>
                                        <td className="align-middle">
                                            <TimePickerWithFormat
                                                className="form-control form-control-sm"
                                                name={`StartTime_${idx}`}
                                                value={item.StartTime || "00:00:00:00"}
                                                disabled={true}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="row mt-2">
                        <div className="col-6 form-group">
                            <label htmlFor="TabView">{lang.channel_label} *</label>
                            <MultiSelect
                                data={getTournamentChannels(scheduleMatchDataItem)}
                                textField="FullChannelName"
                                dataItemKey="_id"
                                value={scheduleMatchDataItem.Channels}
                                onChange={onChangeScheduleMatch}
                                name={"Channels"}
                            />
                        </div>
                        <div className="col-3 form-group">
                            <label htmlFor="TabView">{lang.start_date_label} *</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                name="StartDate"
                                value={scheduleMatchDataItem.StartDate || ""}
                                onChange={onChangeScheduleMatch}
                                disabled={scheduleMatchDataItem?.MediaEpisode?.IsLive}
                                min={moment(new Date(scheduleMatchDataItem.StartDateTime)).utc().format("YYYY-MM-DD")}
                            />
                        </div>

                        <div className="col-3">
                            <label htmlFor="">{lang.start_time_label} *</label>
                            <TimePickerWithFormat
                                className="form-control form-control-sm"
                                name="StartTime"
                                value={scheduleMatchDataItem.StartTime || ""}
                                onChange={onChangeScheduleMatch}
                                disabled={scheduleMatchDataItem?.MediaEpisode?.IsLive}
                            />
                        </div>
                    </div>
                )}
            </BossDialog>
        )}
    </>);
}

export default forwardRef(PlanningLiveEventsTab);
